import { render, staticRenderFns } from "./NavTreeItem.vue?vue&type=template&id=71c43906&"
import script from "./NavTreeItem.vue?vue&type=script&lang=js&"
export * from "./NavTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports